import React from 'react'
import { withRouter } from 'react-router-dom'

import Card from '../../../components/card'
import { AuthContext } from '../../../main/authProvider'
import GeneralServices from '../../../app/service/generalServices'
import { Button } from 'primereact/button'

import * as popUp from '../../../components/toastr'
import ConstantsUtil from '../../../context/constantsUtil'
import ProvisaoService from '../../../app/service/contasAPagar/provisaoService'
import DateIntervalCalendar from '../../../components/calendar/dateIntervalCalendar'
import SelectMenu from '../../../components/selectMenu'
import ProvisaoTable from '../../../components/contasAPagar/provisoes/provisaoTable'
import TooltipButton from '../../../components/tooltipButton'
import { InputSwitch } from 'primereact/inputswitch'
import InputChooseTipoDePagamento from '../../../components/contasAPagar/inputChooseTipoDePagamento'
import InputChooseGrupoDePagamento from '../../../components/contasAPagar/inputChooseGrupoDePagamento'
import { InputNumber } from 'primereact/inputnumber'
import EmpresasMultiSelect from '../../../components/empresas/empresasMultiSelect'
import FormGroup from '../../../components/form-group'


class CheckProvisoesAPagar extends React.Component {

    constructor(){
        super();
        this.generalServices = new GeneralServices();
        this.provisaoService = new ProvisaoService();
        this.generalServices = new GeneralServices();



    }

    state = {

        selectedFilterType: '',
        inputFilterTypeErrorClass: '',

        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,

        initialDate: '',
        initialDateView: '',
        
        finalDate: '',
        finalDateView: '',

        searchProvisaoResult: '',
        valorTotal: '',

        loadingTable: false,
        isSearching: false,
        isFinishedSearch: false,

        habilitaBusca: true,

        forceDateIntervalCalendarUpdate: false,
        isFromNotificacao: false,
        preSetFilterType: '',
        preSetDataInicial: '',
        preSetDataFinal: '',

        pesquisaAvancada: false,

        selectedTipoDePagamento: null,
        selectedTipoDePagamentoMultiSelectList: [],

        selectedGrupoDePagamento: null,
        selectedGrupoDePagamentoMultiSelectList: [],

        valorMinimo: null,
        valorMaximo: null,

        unificar: false,
        selectedEmpresas: [],

        isFromPreSearchConfig: false,

    }

    componentDidMount(){
        this.checkOrigem()
    }
    
    checkOrigem = async () => {
        let dataParcelaPagamentoFromNotificacao = sessionStorage.getItem(ConstantsUtil.checkProvisoesAPagarIsFromNotificacaoSessionStorageKey)
        if(dataParcelaPagamentoFromNotificacao){
            sessionStorage.removeItem(ConstantsUtil.checkProvisoesAPagarIsFromNotificacaoSessionStorageKey)
            let jsDate = GeneralServices.convertCompleteBrStringToJsDate(dataParcelaPagamentoFromNotificacao)
            await this.setState({isFromNotificacao: true})
            await this.setState({selectedFilterType: this.getFilterTypeList()[2].value})
            await this.setState({preSetFilterType: ConstantsUtil.calendarPersonalizadoFilterLabel})
            await this.setState({preSetDataInicial: jsDate})
            await this.setState({preSetDataFinal: jsDate})
            await this.setState({forceDateIntervalCalendarUpdate: true})
        } else if (this.props.preSearchConfig) {
            await this.initFromPreSearchConfig()
        } else if (!this.props.onSelectProvisao) {
            this.setState({selectedFilterType: this.getFilterTypeList()[1].value})
        }
    }

    initFromPreSearchConfig = async () => {
        const config = this.props.preSearchConfig

        const dataBase = config.dataBase
            ? GeneralServices.convertBrStringToJsDate(config.dataBase)
            : new Date()
        dataBase.setHours(0, 0, 0, 0)

        // intervalo [D-10, D+10] em torno da data do extrato
        const dataBaseMenos10 = new Date(dataBase)
        dataBaseMenos10.setDate(dataBaseMenos10.getDate() - 10)
        dataBaseMenos10.setHours(0, 0, 0, 0)

        const dataBasePlus10 = new Date(dataBase)
        dataBasePlus10.setDate(dataBasePlus10.getDate() + 10)
        dataBasePlus10.setHours(0, 0, 0, 0)

        this.setState({
            selectedFilterType: ConstantsUtil.dataPagamentoValue,
            pesquisaAvancada: config.pesquisaAvancada ?? false,
            valorMinimo: config.valorMinimo ?? null,
            valorMaximo: config.valorMaximo ?? null,
            selectedTipoDePagamento: config.tipoDePagamento ?? null,
            preSetFilterType: ConstantsUtil.calendarPersonalizadoFilterLabel,
            preSetDataInicial: dataBaseMenos10,
            preSetDataFinal: dataBasePlus10,
            forceDateIntervalCalendarUpdate: true,
            isFromPreSearchConfig: true,
        })
    }

    getFilterTypeList(){
        return [
            {label: 'Selecione...', value: ''},
            {label: ConstantsUtil.dataLancamentoLabel, value: ConstantsUtil.dataLancamentoValue},
	        {label: ConstantsUtil.dataPagamentoLabel, value: ConstantsUtil.dataPagamentoValue},
        ]
    }    

    getFilterTypeListComDataVencimetno(){
        let list = this.getFilterTypeList()
        list.push({label: ConstantsUtil.dataVencimentoLabel, value: ConstantsUtil.dataVencimentoValue})
        return list
    }    

    handleFilterTypeChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })
        // this.resetDateView()

    }

    handleFilterDateChange = (selectedDateFilterType) => {
        this.setState({selectedDateFilterType})
    }

    handleDateChange = async (initialDate, finalDate) => {

        await this.setState({initialDate})
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})

        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})

    }


    resetView = () => {

        this.setState({
            inputFilterTypeErrorClass: '',
            missingFilterType: false,
            missingAnyDate: false,
            inputEmpresasErrorClass: '',
            errorEmpresasErrorMessage: '',
        })


    }

    checkData = () => {
        var check = true

        if(!this.state.selectedFilterType){
            this.setState({inputFilterTypeErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if(!this.state.selectedDateFilterType){
            this.setState({missingFilterType: true})
            check=false
        }
        
        if(!this.state.initialDate || !this.state.finalDate){
            this.setState({missingAnyDate: true})
            check=false
        }

        if(this.state.initialDate && this.state.finalDate){
            if(this.state.initialDateView > this.state.finalDateView){
                check = false
                popUp.infoPopUp(ConstantsUtil.dataInicialAnteriorFinalMessage)
           }
        }

        if(this.state.unificar){
            if(!this.state.selectedEmpresas || this.state.selectedEmpresas.length === 0){
                this.setState({inputEmpresasErrorClass: ConstantsUtil.primereactInputErrorClass})
                this.setState({errorEmpresasErrorMessage: ConstantsUtil.errorSelecioneEmpresasMessage})
                check = false
            }
        }

        return check;
    }


    montaFiltroPesquisaAvancada = () => {
        if(!this.state.pesquisaAvancada){
            return null
        }
        return {
            tipoDePagamentoList: this.state.selectedTipoDePagamento ? [this.state.selectedTipoDePagamento] : this.state.selectedTipoDePagamentoMultiSelectList,
            grupoDePagamentoList: this.state.selectedGrupoDePagamento ? [this.state.selectedGrupoDePagamento] : this.state.selectedGrupoDePagamentoMultiSelectList,
            valorMinimo: this.state.valorMinimo,
            valorMaximo: this.state.valorMaximo,
        }
    }

    callSearch = () => {
        this.resetView()
        if(this.checkData()){
            this.search()
        }
    }

    search = (fromTable) => {

        if(this.state.isSearching){
            return
        }

        this.setState({isSearching: true})
        this.setState({loadingTable: true})
        this.setState({isFinishedSearch: false})

        const obj = {
            filterType: this.state.pesquisaAvancada ? ConstantsUtil.filtroProvisaoPesquisaAvancada : null,
            filterTypeDate: this.state.selectedFilterType,
            initialDate: this.state.initialDate,
            finalDate: this.state.finalDate,
            filtroPesquisaAvancada: this.montaFiltroPesquisaAvancada(),
        }

        let onSuccess = async (responseData) => {
            this.setState({searchProvisaoResult: responseData.dados})
            this.setState({valorTotal: responseData.valorTotal})
        }

        let onFinally = () => {
            this.setState({loadingTable: false})
            this.setState({isFinishedSearch: true})
            this.setState({isSearching: false})
            this.setState({isFromNotificacao: false})

            if(!fromTable){
                this.toggleButton()
            }
        }

        this.generalServices.searchProvisoes(
            obj,
            onSuccess,
            onFinally,
            this.state.unificar,
            this.state.selectedEmpresas
        )

    }


    voltar = () => {
        this.setState({searchProvisaoResult: ''})
        this.toggleButton()
    }

    toggleButton = () => {
        this.setState({habilitaBusca: !this.state.habilitaBusca})
    }

    handleSelectionTipoDePagamentoChange = async (selectedTipoDePagamento) => {
        await this.setState({selectedTipoDePagamento})
    }

    handleSelectionTipoDePagamentoMultiSelectChange = selectedTipoDePagamentoMultiSelectList => {
        // console.log("selectedTipoDePagamentoMultiSelectList: ", selectedTipoDePagamentoMultiSelectList)
        this.setState({selectedTipoDePagamentoMultiSelectList})
    }

    handleSelectionGrupoDePagamentoChange = (selectedGrupoDePagamento) => {
        this.setState({selectedGrupoDePagamento})
    }

    handleSelectionGrupoDePagamentoMultiSelectChange = selectedGrupoDePagamentoMultiSelectList => {
        // console.log("selectedGrupoDePagamentoMultiSelectList: ", selectedGrupoDePagamentoMultiSelectList)
        this.setState({selectedGrupoDePagamentoMultiSelectList})
    }

    handleValorChange = (event) => {
        // console.log("event: ", event)
        let value = event.value
        if(value === 0){
            value = null
        }
        const name = event.target.name
        this.setState({ [name]: value })
    }

    handleUnificarEmpresasChange = (e) => {
        this.setState({unificar: e.value})
        if(!e.value){
            this.setState({selectedEmpresas: []})
        }
    }

    handleChangePesquisaAvancada = (event) => {
        this.setState({
            pesquisaAvancada: event.value,
            selectedTipoDePagamento: null,
            selectedTipoDePagamentoMultiSelectList: [],
            selectedGrupoDePagamento: null,
            selectedGrupoDePagamentoMultiSelectList: [],
            valorMinimo: null,
            valorMaximo: null,
            unificar: false,
            selectedEmpresas: [],            
        })
    }

    render() {

        const renderDateIntervalCalendar = () => {
                return (
                    <DateIntervalCalendar
                        htmlFor="SelectDatePeriod"
                        label="Escolher período"
                        handleFilterChange={this.handleFilterDateChange}
                        handleDateChange={this.handleDateChange}
                        missingFilterType={this.state.missingFilterType}
                        missingAnyDate={this.state.missingAnyDate}
                        disabled={!this.state.habilitaBusca}
                        forceUpdate={this.state.forceDateIntervalCalendarUpdate}
                        doneForceUpdate={() => this.setState({forceDateIntervalCalendarUpdate: false})}
                        preSetFilterType={this.state.preSetFilterType}
                        preSetDataInicial={this.state.preSetDataInicial}
                        preSetDataFinal={this.state.preSetDataFinal}
                        onFinishSetValues={() => {
                            if(this.state.isFromNotificacao || this.state.isFromPreSearchConfig){
                                this.setState({ isFromPreSearchConfig: false })
                                this.search()
                            }
                        }}
                    />
                )
        }

        const renderButtons = () => {

            if(this.state.isSearching){
                return (
                    <Button
                        label="Buscando ..."
                        icon="pi pi-search"
                        style={{ width: 'auto' }}
                        disabled
                    />
                )
            }

            if(this.state.habilitaBusca){
                return (
                    <Button
                        label="Buscar"
                        icon="pi pi-search"
                        style={{ width: 'auto' }}
                        onClick = {this.callSearch}
                    />
                )
            }
            return (
                <>
                    <Button
                        label="Voltar"
                        icon="pi pi-undo"
                        className="p-button-danger"
                        style={{ width: 'auto' }}
                        onClick = {this.voltar}
                    />
                </>
            )
        }

        const renderTable = () => {
            if( (this.state.isSearching || this.state.isFinishedSearch) && !this.state.habilitaBusca ){
                return (
                    <ProvisaoTable
                        searchProvisaoResult={this.state.searchProvisaoResult}
                        loading={this.state.loadingTable}
                        perfil = {this.context.perfil}
                        search={this.search}
                        valorTotal={this.state.valorTotal}
                        initialDate={this.state.initialDate}
                        finalDate={this.state.finalDate}
                        unificar={this.state.unificar}
                        onSelectProvisao={this.props.onSelectProvisao}
                    />
                )
            }

            if(this.state.isSearching){
                return (
                    <ProvisaoTable
                        loading={true}
                    />
                )
            }
        }

        const renderTooltipFiltroData = () => {
            return (
                <TooltipButton
                    tooltip={`Data de Lancamento: Data da competência em que a provisão foi lançada, independentemente de datas de pagamento ou vencimento.
                        Data de Pagamento: Data em que o pagamento será efetivamente realizado (dia útil).
                        Data de Vencimento: Data de vencimento original do pagamento, independentemente de ser feriado ou final de semana.
                    `}
                    tooltipOptions={{
                        className: 'custom-tooltip',
                    }}
                    icon={<i className="pi pi-question" style={{fontSize: '0.8em'}}></i>}
                    style ={{maxHeight: '25px', maxWidth: '25px'}}
                    className="p-button-rounded p-mr-2"
                />
            )
        }

        const renderTipoDePagamentoInput = () => {
            if(this.state.pesquisaAvancada)
            return (
                <div className='col-md-2'>
                   <InputChooseTipoDePagamento
                        noHTMLFormat
                        simpleView
                        selectedTipoDePagamento={this.state.selectedTipoDePagamento}
                        selectedTipoDePagamentoLabel={this.state.selectedTipoDePagamento?.nome}
                        filtroContaBancaria={{excluiInativos: false}}
                        multiSelect
                        forceShowDialog={this.state.forceShowTipoDePagamentoDialog}
                        hideDialog={this.hideTipoDePagamentoDialog}
                        tipoDePagamentoList={this.state.tipoDePagamentoList}
                        forceUpdate={this.state.forceTipoDePagamentoListInDialog}
                        doneForceUpdate={() => this.setState({forceTipoDePagamentoListInDialog: false})}
                        handleSelectionTipoDePagamentoChange={this.handleSelectionTipoDePagamentoChange}
                        handleSelectionTipoDePagamentoMultiSelectChange={this.handleSelectionTipoDePagamentoMultiSelectChange}
                        inputTipoDePagamentoErrorClass={this.state.inputTipoDePagamentoErrorClass}
                    />
                </div>
                    
            )
        }

        const renderGrupoDePagamentoInput = () => {
            if(this.state.pesquisaAvancada)
            return (
                <div className='col-md-2'>
                   <InputChooseGrupoDePagamento
                        noHTMLFormat
                        selectedGrupoDePagamentoLabel={this.state.selectedGrupoDePagamento?.nome}
                        selectedGrupoDePagamento={this.state.selectedGrupoDePagamento}
                        simpleView
                        multiSelect
                        // enableCadastrarButtonInSimpleView
                        handleSelectionGrupoDePagamentoChange={this.handleSelectionGrupoDePagamentoChange}
                        handleSelectionGrupoDePagamentoMultiSelectChange={this.handleSelectionGrupoDePagamentoMultiSelectChange}
                    />
                </div>
                    
            )
        }

        const renderRangeValores = () => {
            if(this.state.pesquisaAvancada)
            return (
                <>
                    <div
                        className='col-md-1'
                        style={{marginRight: '80px'}}
                    >
                        <label style={{ display: 'block' }}>Valor Mín.</label>
                        <InputNumber
                            name="valorMinimo"
                            value={this.state.valorMinimo}
                            onValueChange={this.handleValorChange}
                            mode="decimal" locale="pt-BR" minFractionDigits={2}
                        />
                    </div>

                    <div className='col-md-2'>
                        <label style={{ display: 'block' }}>Valor Máx.</label>
                        <InputNumber
                            name="valorMaximo"
                            value={this.state.valorMaximo}
                            onValueChange={this.handleValorChange}
                            mode="decimal" locale="pt-BR" minFractionDigits={2}
                        />
                    </div>
                </>
                    
            )            
        }

        const renderUnificarEmpresas = () => {
            if(this.state.pesquisaAvancada && !this.props.onSelectProvisao)
            return (
            <>
                <div
                    style={{
                        marginTop: '0.3rem', marginLeft: '0.5rem', marginRight: '0.5rem'
                    }}
                    className = "col-md-1.5"
                >
                    <h6>Unificar Empresas?</h6>
                    <InputSwitch
                        checked={this.state.unificar}
                        onChange={this.handleUnificarEmpresasChange}
                        // disabled={!this.state.habilitaBusca}
                    />
                </div>

                {renderEmpresasMultiSelect()}

            </>
            )       
        }

        const renderEmpresasMultiSelect = () => {
            if(this.state.unificar){
                return (
                    <div className = "col-md-1">
                    <FormGroup label = "Empresas" >
                    <EmpresasMultiSelect
                        handleChange={(selectedEmpresas) => this.setState({selectedEmpresas})}
                        placeholder="Selecione as empresas para unificar"
                        inputErrorClass={this.state.inputEmpresasErrorClass}
                        errorMessage={this.state.errorEmpresasErrorMessage}
                        // disabled={!this.state.habilitaBusca}
                    />
                    </FormGroup>
                    </div>
                )
            }
        }
        
        return (
            <div className="bs-docs-section" >

            <Card title = "Provisões de Pagamento">
                <div className="col-md-12">
                    
                <div className="row">

                <div className = "col-md-3">
                    <div className = "row">
                    <div className = "col-md-5">
                    <label htmlFor="filtro">Filtrar Por</label>
                    </div>
                    <div className = "col-md-1">
                        {renderTooltipFiltroData()}
                    </div>
                    </div>
                    <SelectMenu
                        className={"form-control " + this.state.inputFilterTypeErrorClass }
                        name="selectedFilterType"
                        list= {this.getFilterTypeListComDataVencimetno()}
                        value={this.state.selectedFilterType}
                        onChange={this.handleFilterTypeChange}
                        disabled={!this.state.habilitaBusca}
                    />
                    <div className="invalid-feedback">{ConstantsUtil.preecnhaLabel}</div>
                </div>
                
                    {renderDateIntervalCalendar()}

                </div>

                <br />

                <div className='row'>
                
                    <div className='col-md-1'>
                        <h6>Pesquisa Avançada?</h6>
                        <InputSwitch
                            checked={this.state.pesquisaAvancada}
                            onChange={this.handleChangePesquisaAvancada}
                            // disabled={this.state.selectedFilterType !== ConstantsUtil.dataLancamentoValue}
                        />
                    </div>

                    {renderTipoDePagamentoInput()}
                    {renderGrupoDePagamentoInput()}
                    {renderRangeValores()}
                    {renderUnificarEmpresas()}
                
                </div>
                
                <br />

                    
                    
                {renderButtons()}


                <br />

                <br />                

                {renderTable()}

                </div>
            </Card>
            <div className="d-flex "/>

        </div>
        )

    }

}

CheckProvisoesAPagar.contextType = AuthContext

export default withRouter(CheckProvisoesAPagar)
